<!-- 角色授权(按权限) -- 从表 -->
<template>
  <div>
    <Table
       ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"11",
        name:"角色授权权限明细",
        parentId:"ROLE_ID",
        parentName:"角色授权(按权限)",
        parentPath:"/system/roleAuthorization",
        dataClass:2,
        addClick,
      }'
    >
    </Table>
    <m-selectorcc :visible.sync="select" :select='{
      searchslotType: "",
      searchslottitle: "请选择角色",
      multiple: true,
      searchslotId: 105,
      searchslotkey: { ID: "ID" },
      filterWhere:$route.query.ROLE_ID,//过滤
      colname:"aqxsqxzqx"
    }' @listenEvent="fn"></m-selectorcc>
  </div>
</template>

<script>
import Table from "@/components/table/dataTablecSon";
import MSelectorcc from "@/components/table/MSelectorcc";
import { addShow } from "@/api/table/table";
export default {
  components: {
    Table,
    MSelectorcc,
  },
  data() {
    return {
      firstEnter:true,
      select :false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 新增打开选择器
    addClick(){
      this.select = true;
    },
    // 选择器 回填
    fn(e){
      console.log(e);
      this.select = false;
      addShow({
        opid: 11,
        dataClass: 2,
        data: {TEAM_ID:e.ID.join(","),ROLE_ID:this.$route.query.ROLE_ID},
        runId: this.$route.query.runId,
        otherCol:"TEAM_ID"
      }).then(res=>{
        this.$refs.table.$refs.child.onLoad();
      });
    },
  },
  created() {},
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  },
};
</script>

<style></style>